import { render, staticRenderFns } from "./driverAccountPage.vue?vue&type=template&id=31841beb&scoped=true"
import script from "./driverAccountPage.vue?vue&type=script&lang=js"
export * from "./driverAccountPage.vue?vue&type=script&lang=js"
import style0 from "./driverAccountPage.vue?vue&type=style&index=0&id=31841beb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31841beb",
  null
  
)

export default component.exports